import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"file-chart, document"} maskId="square-filled-radius-0-stroke-1-IconFileChart"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 2H4V22H20V9.5H12.5V2ZM9 16H8V19H9V16ZM12.5 13V19H11.5V13H12.5ZM16 15H15V19H16V15Z" fill="currentColor"/><path d="M13.5 2.29289L19.7071 8.5H13.5V2.29289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFileChart;
